module.exports = __webpack_public_path__ + "static/img/tb_rz.c3560e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tb_rz.png
// module id = 8Iy5
// module chunks = 0